import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/boris/app/gs/client-app/node_modules/.pnpm/next-intl@4.6.1_next@15.4.11_@babel+core@7.28.5_@playwright+test@1.59.1_react-dom@19.2._b32f418042dd1376d469e4444d9931b9/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/boris/app/gs/client-app/src/views/public/three-sixty-steps/Head.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/boris/app/gs/client-app/src/views/public/three-sixty-steps/Step.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/boris/app/gs/client-app/src/views/public/three-sixty-steps/StepFive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/boris/app/gs/client-app/src/views/public/three-sixty-steps/StepFour.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/boris/app/gs/client-app/src/views/public/three-sixty-steps/StepThree.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/boris/app/gs/client-app/src/views/public/three-sixty-steps/StepTwo.tsx");
